import {IInsurance} from "@/model/Insurance/Insurance"

export interface IHasInsurancesSelected {
    getInsurancesSelected(): IInsurance[]
    getInsurancesSelectedMap(): Map<string, IInsurance>
    addInsuranceSelected(insurance: IInsurance): void
    removeInsuranceSelected(insurance: IInsurance): void
}

function hasInsurancesSelected<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasInsurancesSelected {
        private insurancesSelected: IInsurance[] = []
        private insurancesSelectedMap: Map<string, IInsurance> = new Map()

        constructor(...args: any[]) {
            super(...args);
        }

        public getInsurancesSelected(): IInsurance[] {
            return this.insurancesSelected
        }
        public getInsurancesSelectedMap(): Map<string, IInsurance> {
            return this.insurancesSelectedMap
        }
        public addInsuranceSelected(insurance: IInsurance): void {
            if (this.insurancesSelectedMap.has(insurance.getIdFull())) return
            this.insurancesSelected.push(insurance)
            this.insurancesSelectedMap.set(insurance.getIdFull(), insurance)
        }
        public removeInsuranceSelected(insurance: IInsurance): void {
            if (!this.insurancesSelectedMap.has(insurance.getIdFull())) return
            this.insurancesSelected = this.insurancesSelected.filter((existingInsurance: IInsurance) => existingInsurance.getIdFull() !== insurance.getIdFull())
            this.insurancesSelectedMap.delete(insurance.getIdFull())
        }
    };
}

export default hasInsurancesSelected